import request from '../axios';

export const getStoreInfo = async (storeId: string) => {
  const {data}: {data: IStoreInfo} = await request.get(
    `/api/v2/store/store-info?guid=` + storeId,
  );
  return data;
};

